import * as React from 'react';
import PropTypes from 'prop-types';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Fade
} from "@mui/material"


export default function ConfirmationDialog(props) {
  const { onClose,onConfirm, value: valueProp, open, ...other } = props;
  const [value, setValue] = React.useState(valueProp);

  React.useEffect(() => {
    if (!open) {
      setValue(valueProp);
    }
  }, [valueProp, open]);


//   const handleCancel = () => {
//     onClose();
//   };

//   const handleOk = () => {
//     onConfirm()
//   };


  return (
    <Dialog
      open={open}
      {...other}
    >
      <DialogTitle>{props.title}</DialogTitle>
      <DialogContent dividers>
        {props.message}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={props.processing}>
          Cancel
        </Button>
        <Button onClick={onConfirm} disabled={props.processing}>{props.processing?props.processingLabel:props.confirmLabel}</Button>
      </DialogActions>
    </Dialog>
  );
}

ConfirmationDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
};
